import { NavLink } from 'react-router-dom';
import './style.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header__wrapper">
        <h1 className="header__title">
          <strong>
            От облаков точек
            <br />
            <span className="header__title-nowrap">к документации и BIM-моделям</span>
          </strong>
        </h1>

        <div className="header__text">
          <p>Создаём точную документацию и BIM-модели для дальнейшего проектирования.</p>
        </div>

        <div className="header__actions">
          <NavLink to="/projects" className="btn">
            Посмотреть примеры работ
          </NavLink>

          <NavLink to="/contacts" className="btn btn--secondary">
            Получить оценку проекта
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Header;
